import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import ChatHeader from "./ChatHeader";
import ChatBody from "./ChatBody";


class ChatContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        userImage     : '',
        userPercentage: 0,
        totalFriend   : 0,
        totalPost     : 0
  
      };
    }
    componentDidMount() {
      
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
     
    }
    render() {
      return (
        <div className="container">
         
          <ChatBody />
        </div>

      );
    }
}

const mapStateToProps = state => {
 
  return {

   
    
  }
}



export default connect(
  mapStateToProps
)(ChatContainer);

